<ion-app>
  <ion-header>
    <div class="header-row">
      <div class="start">
        <ion-button fill="clear" (click)="goBack()" *ngIf="firestoreService.currentBank || firestoreService.updates">
          <ion-icon name="arrow-back"></ion-icon>        
        </ion-button>
      </div>
      <div class="center">
        <ion-title [ngSwitch]="!!firestoreService.currentBank">
          <ng-container *ngSwitchCase="false" [ngSwitch]="!!firestoreService.updates">
            <ng-container *ngSwitchCase="false">Bank Accounts</ng-container>
            <ng-container *ngSwitchCase="true">Updates</ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="true">Transactions - {{firestoreService.currentBank.bankName}}</ng-container>
        </ion-title>
      </div>
      <div class="end">
        <ion-button fill="clear" (click)="openMenu(firestoreService.currentBank ? 'transactionMenu' : 'bankAccountMenu')" [disabled]="firestoreService.updates">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </div>
    </div>
    <!-- Arbitrarily hidden in the header -->
    <input class="ion-hide" #f type="file" (change)="importAccount($event);" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
    <input class="ion-hide" #g type="file" (change)="firestoreService.importBrf($event);" accept=".brf, .zip">
  </ion-header>
  <ion-content>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-content>

  <ion-footer>
    <div class="bottom-row">
      <div class="section">
        Last updated - {{ (firestoreService.currentBank ?? firestoreService.bankAccountsLocal[0])?.latestUpdate | date:'dd/MM/yy, h:mm a' }}
      </div>
      <div class="section">
        <ng-container *ngIf="firestoreService.developer">
          Developer Mode (refresh to end)
        </ng-container>
      </div>
      <div class="section" [class.italics]="!firestoreService.noMoreTransactions">
        <ng-container *ngIf="firestoreService.currentBank">
          Subtotal: {{ (firestoreService.paginatedTransactions | sumField : 'transaction') | currency }} (Selected: {{ (firestoreService.paginatedTransactions | sumField : 'transaction' : firestoreService.checkedTransactions) | currency }})
        </ng-container>
      </div>
    </div>
  </ion-footer>

</ion-app>

<ion-menu *ngIf="'bankAccountMenu' as bankMenu" side="end" [menuId]="bankMenu" contentId="main">
  <ion-content>
    

    <div class="menu-content">

      <div class="menu-top">
        <ion-item button (click)="exportAccounts(bankMenu)" [disabled]="checkSelected()">
          <ion-label>
            Export
          </ion-label>
          <ion-icon slot="end" name="download-outline"></ion-icon>
        </ion-item>
        <!-- <ion-item button (click)="firestoreService.subscribeAccount(bankMenu)" [disabled]="checkSelected()">
          <ion-label>
            Subscribe
          </ion-label>
          <ion-icon slot="end" name="notifications-outline"></ion-icon>
        </ion-item> -->
        <ion-item button (click)="tagAccount()" [disabled]="checkSelected()">
          <ion-label>
            Edit tags
          </ion-label>
          <ion-icon name="pricetag" slot="end"></ion-icon>
        </ion-item>
        <ion-item button (click)="firestoreService.fixDuplicates()" *ngIf="firestoreService.developer">
          <ion-label>
            Fix Duplicates
          </ion-label>
          <ion-icon slot="end" name="build-outline"></ion-icon>
        </ion-item>
        <ion-item button (click)="goUpdates()" *ngIf="firestoreService.developer">
          <ion-label>
            View Updates
          </ion-label>
          <ion-icon slot="end" name="archive-outline"></ion-icon>
        </ion-item>
      </div>

      <div class="menu-bot">
        <div class="item-divider"></div>
        <ion-item button (click)="developerMode(bankMenu)" *ngIf="authService.user?.email === 'hans.taylor@dorado.com.au'">
          Developer mode
          <ion-icon slot="end" name="bug"></ion-icon>
        </ion-item>
        <ion-item button (click)="signout(bankMenu)">
          Sign out
          <ion-icon slot="end" name="exit"></ion-icon>
        </ion-item>
      </div>

    </div>

  </ion-content>
</ion-menu>

<ion-menu side="end" menuId="transactionMenu" contentId="main" (ionWillOpen)="refreshNarrationIndexStatus()">
  <ion-content>

    <div style="position: relative; width: 100%; height: 100%;">
      <ion-item button (click)="exportAccount()">
        <ion-label>
          Export
        </ion-label>
        <ion-icon slot="end" name="download-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="exportAccountWithUpdates()">
        <ion-label>
          Export with Updates
        </ion-label>
        <ion-icon slot="end" name="download-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="importAccountCheck(f)">
        <ion-label>
          Import
        </ion-label>
        <ion-icon slot="end" name="cloud-upload-outline"></ion-icon>
      </ion-item>
      <!-- <ion-item button (click)="assignSyndicate()">
        <ion-label>
          Assign to Syndicate
        </ion-label>
        <ion-icon slot="end" name="bookmark"></ion-icon>
      </ion-item> -->
      <ion-item button (click)="tagTransaction()" [disabled]="!(firestoreService.paginatedTransactions | filterNotBlank : firestoreService.checkedTransactions)?.length">
        <ion-label>
          Edit tags
        </ion-label>
        <ion-icon slot="end" name="pricetag"></ion-icon>
      </ion-item>
      <ion-item button (click)="viewSummary()" *ngIf="!(firestoreService?.currentBank?.tags | includes: 'Bpay')">
        <ion-label>
          View Summary
        </ion-label>
        <ion-icon slot="end" name="grid-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="removeRecon()" [disabled]="!(firestoreService.paginatedTransactions | filterHasProp : 'recon' : firestoreService.checkedTransactions)?.length">
        <ion-label>
          Remove Reconciliation
        </ion-label>
        <ion-icon slot="end" name="trash-bin-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="mergeTransactions()" [disabled]="!(firestoreService.paginatedTransactions | filterNotBlank : firestoreService.checkedTransactions)?.length || (firestoreService.paginatedTransactions | filterHasProp : 'recon' : firestoreService.checkedTransactions)?.length">
        <ion-label>
          Merge Transactions
        </ion-label>
        <ion-icon slot="end" name="contract-outline"></ion-icon>
      </ion-item>
      <ng-container *ngIf="firestoreService?.currentBank?.tags | includes: 'Bpay'">
        <ion-item button (click)="uiService.importBRFCheck(g, true)">
          <ion-label>
            Import Bpay BRF
          </ion-label>
          <ion-icon slot="end" name="cloud-upload-outline"></ion-icon>
        </ion-item>
        <ion-item button (click)="viewSummary(true)">
          <ion-label>
            View Bpay Summary
          </ion-label>
          <ion-icon slot="end" name="grid-outline"></ion-icon>
        </ion-item>
        <ion-item button>
          <ion-label>
            View Bpay Transactions
          </ion-label>
          <ion-toggle slot="end" [ngModel]="firestoreService.viewBpay" (ngModelChange)="firestoreService.switchBpay($event)"></ion-toggle>
        </ion-item>
      </ng-container>
      <ion-item button (click)="buildNarrationIndex()">
        <ion-label class="ion-text-wrap">
          {{ narrationIndexStatus?.built ? "Rebuild Search Index" : "Build Search Index" }}
          <p *ngIf="narrationIndexChecking && !narrationIndexStatus">Checking index...</p>
          <p *ngIf="narrationIndexStatus" [class.index-warning]="narrationIndexStatus.warn">
            {{ narrationIndexStatus.detail }}
          </p>
        </ion-label>
        <ion-icon slot="end" name="search-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="clearNarrationIndex()" *ngIf="firestoreService.developer" [disabled]="narrationIndexStatus && !narrationIndexStatus.built">
        <ion-label>
          Clear Search Index
        </ion-label>
        <ion-icon slot="end" name="trash-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="firestoreService.fixDup(firestoreService.currentBank.bankId)" *ngIf="firestoreService.developer">
        <ion-label>
          Fix Duplicates
        </ion-label>
        <ion-icon slot="end" name="build-outline"></ion-icon>
      </ion-item>
      <ion-item button (click)="deleteTransactions()" [disabled]="!(firestoreService.checkedTransactions | filterNotBlank)" *ngIf="firestoreService.developer">
        <ion-label>
          Delete Transactions
        </ion-label>
        <ion-icon slot="end" name="trash-outline"></ion-icon>
      </ion-item>

      <ion-item button (click)="signout('transactionMenu')" style="position: absolute; bottom: 0; width: 100%;">
        Sign out
        <ion-icon slot="end" name="exit"></ion-icon>
      </ion-item>

    </div>

  </ion-content>
</ion-menu>